import * as React from 'react';
import { ArticleHeading3, ArticleHeading4, Image, InlineText1 } from '@cian/ui-kit';
import { IBank } from '../../types/developer/banks';
import * as styles from './BankCard.css';

interface IBankCardProps {
  bank: IBank;
}

export function BankCard({ bank }: IBankCardProps) {
  return (
    <article key={bank.id} className={styles['card']}>
      <div className={styles['card__image']}>
        <Image src={bank.logo} width={48} height={48} objectFit="cover" data-testid="BankCardImage" />
      </div>

      <div className={styles['card__title']}>
        <ArticleHeading3 data-testid="BankCardTitle">{bank.name}</ArticleHeading3>
      </div>

      <div className={styles['card__item']}>
        <InlineText1>Процентная ставка</InlineText1>
        <ArticleHeading4 data-testid="BankCardInterestRate">{bank.interestRate}</ArticleHeading4>
      </div>

      <div className={styles['card__item']}>
        <InlineText1>Первый взнос</InlineText1>
        <ArticleHeading4 data-testid="BankCardDownPayment">{bank.downPayment}</ArticleHeading4>
      </div>
    </article>
  );
}
